import { Input } from 'antd';

export const CODE_LENGTH = 6;

interface CodeInputProps {
  /** Filled in by the surrounding Form.Item. */
  value?: string;
  onChange?: (code: string) => void;
  /** Called once every box holds a digit, so the form can submit without a click. */
  onComplete?: (code: string) => void;
  autoFocus?: boolean;
}

/** Keeps the spaces Ant uses for empty boxes, so a rejected character doesn't shift the digits after it. */
function digitsOnly(text: string): string {
  return text.replace(/[^\d ]/g, '');
}

/**
 * A 6-digit sign-in code as one box per digit. Typing, pasting or a phone's code autofill fills the boxes in
 * turn. Ant only reports a value once all six are filled, so `onChange` and `onComplete` both mean "complete".
 */
export function CodeInput({ value, onChange, onComplete, autoFocus }: CodeInputProps) {
  function handleChange(code: string) {
    onChange?.(code);
    onComplete?.(code);
  }

  return (
    <Input.OTP
      length={CODE_LENGTH}
      value={value}
      onChange={handleChange}
      formatter={digitsOnly}
      inputMode="numeric"
      autoComplete="one-time-code"
      autoFocus={autoFocus}
      aria-label={`${CODE_LENGTH}-digit code`}
    />
  );
}
